import { defaultInitialState } from '../utils';
import { MEMBERSHIP_CHANGE_PLAN, MEMBERSHIP_CHANGE_PLAN_DONE, MEMBERSHIP_CHANGE_PLAN_ERROR, MEMBERSHIP_CHANGE_PLAN_RESET } from './actionTypes';
const initialState = defaultInitialState;
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case MEMBERSHIP_CHANGE_PLAN:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case MEMBERSHIP_CHANGE_PLAN_DONE:
            return Object.assign(Object.assign({}, state), { isUpdated: true, isLoading: false, error: false, errorMessage: null });
        case MEMBERSHIP_CHANGE_PLAN_ERROR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case MEMBERSHIP_CHANGE_PLAN_RESET:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map